import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    active: boolean;
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const ActivateDeactivateTeamModal = ({ active, open, onCancel, onConfirm }: Props) => {
    const title = active ? 'Deactivate Team' : 'Activate Team';
    const subtitle = active ? 'Are you sure you want to deactivate the team?' : 'Activate Team?';
    const confirmationButtonText = active ? 'Deactivate Team' : 'Activate Team';
    const buttonType = active ? 'error' : 'default';

    return (
        <ConfirmationModal
            width={400}
            open={open}
            onCancel={onCancel}
            onConfirm={onConfirm}
            title={title}
            confirmButtonText={confirmationButtonText}
            content={<Typography>{subtitle}</Typography>}
            type={buttonType}
        />
    );
};

export default ActivateDeactivateTeamModal;
